<template>
  <v-form>
      <v-row align="center" justify="center">
          <h3><b>{{$t('json.regparam')}}</b></h3>
      </v-row>
      <v-row align="center" justify="center" v-for="p in BatchSettings.Params" :key="p.Id">
        <v-col :cols="3">
            <v-text-field  clearable v-model="p.Name" :disabled="disable || preview" @change="onChange" :label="$t('json.name')" :rules="[() => !!p.Name || $t('json.ruleempty')]" required validate-on-blur></v-text-field>
        </v-col>
        <v-col :cols="3">
            <v-text-field clearable v-model="p.Value" :disabled="disable || preview" @change="onChange" @click:clear="clearProp(p)" :label="$t('json.value')" :rules="[() => !!p.Value || $t('json.ruleempty')]" required validate-on-blur></v-text-field>
        </v-col>
        <v-col :cols="1" style="text-align: center;">
            <v-btn icon="" @click="removeProperty(BatchSettings.Params, p)" :disabled="disable || preview"><v-icon>mdi-server-remove</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col :cols="3">
          <v-btn v-show="!preview" block @click="addParameter" :disabled="disable">{{ $t('json.addreqparam') }}</v-btn>
        </v-col>
      </v-row>
  </v-form>
</template>

<script>
import Models from '@/Models'
import { clearProp } from '@/composable/FieldMethods.js'
export default {
  name: 'RequestParams',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    BatchSettings () {
      return this.props
    }
  },
  methods: {
    clearProp,
    async removeProperty (arr, p) {
      const index = arr.indexOf(p)
      if (index > -1) arr.splice(index, 1)
      this.$emit('changeSettings')
    },
    getId () {
      return Math.floor(Math.random() * 1000000)
    },
    async addParameter () {
      const p = Models.UploadParam
      p.Id = this.getId()
      this.BatchSettings.Params.push(p)
    },
    async onChange (val) {
      console.log('chnageSettings Request parameter')
      this.$emit('changeSettings')
    }
  }
}
</script>
